module.exports = __webpack_public_path__ + "static/media/liverpoolCadastre.dd2de054.geojson";